import { createActions } from 'redux-actions';

import types from 'state/addresses/actionTypes';

const { addresses } = createActions({
  [types.SET_LOADED_ADDRESSES]: ({
    addresses: loadedAddresses,
    next,
    count,
  }) => ({
    data: loadedAddresses,
    next,
    count,
  }),
  [types.SET_LOADED_VENUES_OF_INTEREST]: ({
    addresses: loadedPointsOfInterest,
  }) => ({
    venues: loadedPointsOfInterest,
  }),
  [types.SET_LOADED_ADDRESSES_OF_INTEREST]: ({
    addresses: loadedPointsOfInterest,
  }) => ({
    addresses: loadedPointsOfInterest,
  }),
  [types.SET_CITY_DATA]: ({ cityData }) => ({
    cityData,
  }),
  [types.loadMoreAddresses$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
  [types.searchAddresses$]: ({ shipmentKey, stopType, text }) => ({
    shipmentKey,
    stopType,
    text,
  }),
  [types.blurAddresses$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
  [types.fetchAddresses$]: () => ({}),
  [types.cleanAddress$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
  [types.zipcodeTyped$]: ({ country, zipcode }) => ({
    country,
    zipcode,
  }),
  [types.openAddressModal$]: ({ shipmentKey, stopType, isEditMode }) => ({
    shipmentKey,
    stopType,
    isEditMode,
  }),
  [types.openNewAddressModal$]: () => ({}),
  [types.closeCreateAddress$]: () => ({}),

  [types.submitDeleteAddress$]: ({ addressId, onClose }) => ({
    addressId,
    onClose,
  }),

  [types.submitCreateAddress$]: ({ formData, onClose }) => ({
    formData,
    onClose,
  }),
  [types.submitCreateAddressForShipment$]: ({
    formData,
    shipmentKey,
    stopType,
  }) => ({
    formData,
    shipmentKey,
    stopType,
  }),
  [types.changeAddress$]: ({ address, shipmentKey, stopType }) => ({
    address,
    shipmentKey,
    stopType,
  }),
  [types.openEditAddress$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
  [types.formChange$]: ({ name, value }) => ({
    name,
    value,
  }),
  [types.searchVenuesOfInterest$]: ({
    text,
    postalCode,
    countryCode,
    city,
  }) => ({
    text,
    postalCode,
    countryCode,
    city,
  }),
  [types.searchAddressesOfInterest$]: ({
    text,
    postalCode,
    countryCode,
    city,
  }) => ({
    text,
    postalCode,
    countryCode,
    city,
  }),
  [types.searchStructuredAddress$]: ({
    text,
    postalCode,
    countryCode,
    city,
  }) => ({
    text,
    postalCode,
    countryCode,
    city,
  }),
  [types.clearVenuesOfInterest$]: () => ({}),
  [types.clearAddressesOfInterest$]: () => ({}),
});

export default addresses;
